import { getCodeRecordPage, verifyCode } from '@/api/code'

export class CodeController {
  static verify (code: string) {
    return verifyCode(code)
  }

  static async page (params: COMMON.API.QueryParams) {
    return await getCodeRecordPage(params)
  }
}
